import React, { useEffect, useState, useRef, useMemo } from "react";
import { Col, Row } from "react-bootstrap";
import { Toast } from './Toast';
import { TabPane, Button, Dimmer, Loader, Card, Icon, Input, Image, Label, Segment, Accordion, List, Popup} from "semantic-ui-react";
import { useMyGlobal } from './GlobalData';
import axios from "axios";
import noDataImage from '../assets/no_data.png';

const PickUpInStore = ({ 
  idProduct, 
  data,
  setSelectedWarehouse,
  setSelectedSizePickUp,
  setSelectedBarcodePickUp,
  defaultWarehouse,
  pickUpLoader
}) => {
  const [panes, setPanes] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);
  const [activeIndexCity, setActiveIndexCity] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [activeWarehouse, setActiveWarehouse] = useState(null);
  const [warehouseDetailData, setWarehouseDetailData] = useState({});
  const [isManyWarehouse, setIsManyWarehouse] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [warehouseLoader, setWarehouseLoader] = useState(false);
  const { token, windowWidth, windowHeight, idCart } = useMyGlobal();
  const scrollRef = useRef();
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, [searchQuery]);

  useEffect(() => {
    if (Array.isArray(data)) {
      const cleanedData = data.filter(item => !item.barcode.includes('\r') && !item.barcode.includes('\n'));
      const uniqueMap = new Map();
      cleanedData.forEach((item) => {
        const sizeKey = item.size.trim();
        const barcode = item.barcode.trim();
        const hasSize = item.has_item ? item.has_item : false;
        const key = `${barcode}_${sizeKey}`;

        if (uniqueMap.has(key)) {
          const existing = uniqueMap.get(key);
          existing.qty += parseInt(item.qty);
        } else {
          uniqueMap.set(key, {
            barcode,
            size: sizeKey,
            qty: parseInt(item.qty),
            hasSize: hasSize
          });
        }
      });

      const sortedArray = Array.from(uniqueMap.values()).sort(
        (a, b) => parseFloat(a.size) - parseFloat(b.size)
      );

      setPanes(sortedArray);
    }
  }, [idProduct, data]);

  const isMobile = windowWidth < 992;

  const getWarehouseDetail = async (idProduct, barcode) => {
    setActiveWarehouse(null)
    setSelectedWarehouse(null)
    setWarehouseLoader(true);
    try {
      const param = new URLSearchParams();
      param.append("id_product", idProduct);
      param.append("barcode", barcode);
      param.append("id_cart", idCart);

      const response = await axios({
        method: "POST",
        url: `${process.env.REACT_APP_SRV_API_URL}controler/product.php/?index=27`,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: token,
        },
        data: param,
      });

      if (response.data.state === 200) {
        setWarehouseDetailData(response.data.data || {});
      } else {
        setWarehouseDetailData({});
      }
    } catch (error) {
      console.error(error);
      setWarehouseDetailData({});
    } finally {
      setWarehouseLoader(false);
    }
  };

  const capitalizeWords = (str) => {
    const words = str.trim().toLowerCase().split(/\s+/);
    let result = '';
    
    for (let word of words) {
        const capitalizedWord = word.charAt(0).toUpperCase() + word.slice(1);
        if ((result + capitalizedWord + ' ').length > 40) break;
        result += capitalizedWord + ' ';
    }

    return result.trim();
      // return str
      //     .toLowerCase()
      //     .split(' ')
      //     .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      //     .join(' ');
  };

  function truncateText(text) {
    let maxLength = isMobile ? 20 : 30
    const trimmedLength = maxLength - 3;
    if (typeof text !== 'string') return '';
    if (text.length <= maxLength) return text;
    return text.substring(0, trimmedLength).trim() + '...';
  }

  function formatIndonesianCity(name) {
      if (/^Kota\s+/i.test(name)) {
        return name.replace(/^Kota\s+/i, '');
      }
      if (/^Kabupaten\s+/i.test(name)) {
        return name.replace(/^Kabupaten\s+/i, '');
      }
      return name;
  }

  useEffect(() => { 
    const data = Object.values(warehouseDetailData)
    const isValid = data.length > 1
    setIsManyWarehouse(isValid)
  }, [warehouseDetailData]);
  
    
  useEffect(() => {
    if (panes.length > 0) {
      // let selected = 0
      // for (let index = 0; index < panes.length; index++) {
      //   let validate = panes[index].qty > 0;
      //   if(validate){
      //     selected = index
      //     break;
      //   }
      // }
      // setActiveIndex(selected);
      // getWarehouseDetail(idProduct, panes[selected].barcode);
      // setSelectedBarcodePickUp(panes[selected].barcode);
      // setSelectedSizePickUp(panes[selected].size);
    }
  }, [panes]);

  const WarehouseAccordionGrouped = ({
    warehouses,
    activeWarehouse,
    setActiveWarehouse,
    setSelectedWarehouse,
    isMobile,
    scrollRef,
    pickUpLoader
  }) => {
    const groupedByCity = warehouses.reduce((acc, warehouse) => {
      const city = warehouse.prov || 'Unknown City';
      if (!acc[city]) acc[city] = [];
      acc[city].push(warehouse);
      return acc;
    }, {});

    const handleAccordionClick = (index) => {
      if (!pickUpLoader) {
        setActiveIndexCity((prev) => (prev === index ? null : index));
      }
    };

    return (
      <Accordion fluid>
        {Object.entries(groupedByCity).map(([city, cityWarehouses]) => (
          <div key={city}>
            <Accordion.Title
              active={activeIndexCity === city}
              index={city}
              onClick={() =>{
                handleAccordionClick(city);
              } }
              style={{
                cursor: 'pointer',
                fontSize: '1.2rem',
                paddingBottom: '0.5rem',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Icon
                name={activeIndexCity === city ? 'angle down' : 'angle right'}
                color={selectedCity === city ? 'orange' : 'grey'}
              />
              <span
                style={{ marginLeft: '0.5rem' }}
                className="py-1 text-secondary"
              >
                <h5 style={{ color: selectedCity === city ? '#f2711c' : '#767676' }}>
                  {capitalizeWords(formatIndonesianCity(city))}
                </h5>
              </span>
            </Accordion.Title>

            <Accordion.Content active={activeIndexCity === city} className="my-2">
              <List animated verticalAlign='middle'>
                  {cityWarehouses.map((warehouse) => (
                    <Segment
                      key={warehouse.id_warehouse}
                      onClick={() => {
                        if(defaultWarehouse !== warehouse.id_warehouse && defaultWarehouse !== "0" && defaultWarehouse !== null) {
                          Toast.fire({
                              timer: 6000,
                              icon: "warning",
                              text: "Only the showroom you previously selected can be used. To choose a different showroom, you'll need to empty your cart.",
                              position: "center",
                              showCloseButton: true
                          })
                        } else if(defaultWarehouse === "0") {
                          Toast.fire({
                              timer: 6000,
                              icon: "warning",
                              text: "Your cart has been set as Delivery Order. You'll need to empty your cart first then try again to make Pick Up in Store order.",
                              position: "center",
                              showCloseButton: true
                          })
                        } else if (!pickUpLoader) {
                          setActiveIndexCity(city);
                          setSelectedCity(city);
                          const scrollTop = scrollRef.current?.scrollTop;
                          setActiveWarehouse(warehouse.id_warehouse);
                          setSelectedWarehouse(warehouse.id_warehouse);
                          requestAnimationFrame(() => {
                            if (scrollRef.current && scrollTop !== undefined) {
                              scrollRef.current.scrollTop = scrollTop;
                            }
                          });
                        }
                      }} 
                      style={{
                        borderBottom:
                        activeWarehouse === warehouse.id_warehouse
                          ? '2px solid #f2711c'
                          : '1px solid #d4d4d5',
                        padding: '1em',
                        borderRadius: '0.5em',
                        marginBottom: '1em',
                        cursor: pickUpLoader ? 'not-allowed' : 'pointer',
                      }}
                      paded
                    >
                      <List.Item>
                          <List.Content>
                            <List.Header as={!isMobile ? "h3" : "h5"}>
                              <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                flexWrap: 'wrap', // opsional, agar responsif
                                gap: '0.5em' // opsional, beri jarak antar elemen
                              }}>
                                {/* <span>{truncateText(warehouse.name)}</span> */}
                                <span>{warehouse.name}</span>
                                {activeWarehouse === warehouse.id_warehouse ? (
                                  <Label color="orange" size="tiny">
                                    <Icon name="thumbtack" />
                                    Selected
                                  </Label>
                                ) : warehouse.qty > 1 ? (
                                  <Label basic color="green" size="tiny">
                                    <Icon name="check circle outline" />
                                    Available
                                  </Label>
                                ) : warehouse.qty === 1 ? (
                                  <Label basic color="red" size="tiny">
                                    <Icon name="exclamation" />
                                    One left!
                                  </Label>
                                ) : null}
                              </div>
                            </List.Header>
                            {/* <List.Description>
                              <Icon name="warehouse" />
                              &nbsp;&nbsp;{warehouse.alias}
                            </List.Description> */}
                          </List.Content>
                      </List.Item>
                    </Segment>
                  ))}
              </List>
            </Accordion.Content>
          </div>
        ))}
      </Accordion>
    );
  };

  const filteredWarehouses = useMemo(() => {
    if (warehouseDetailData && Object.keys(warehouseDetailData).length > 0) {
      const query = searchQuery.toLowerCase().trim();
      const warehousesArray = Object.values(warehouseDetailData);
      return warehousesArray.filter(wh => 
        wh.name.toLowerCase().includes(query) ||
        wh.city.toLowerCase().includes(query) ||
        wh.prov.toLowerCase().includes(query)
      );
    }
    return [];
  }, [searchQuery, warehouseDetailData]);


  const WarehouseCards = ({ warehouseDetailData }) => {
    const warehouses = Object.values(warehouseDetailData || {});
    if (warehouses.length === 0) 
      return <div style={!isMobile ? { position: "relative", top: "-3rem"} : {}}>
        <h4 className="text-center">
          <Icon className="text-danger" name='exclamation' /> No showroom data available
        </h4>
        <Image src={noDataImage} size="medium" centered fluid />
      </div>;

    return (
      <div 
        style={!isMobile ? { position: "relative", top: "-3.5rem"} : {}}
      >
        <h4 className={!isMobile ? 'pb-3' : 'pb-1'} style={{ textAlign: "center" }}>Choose the showroom</h4>
        <Row>
            <Col sm={12}>
              <div className="text-center pb-3">
                <Input
                  ref={inputRef}
                  className="w-75"
                  style={{
                    borderRadius: '1em',
                  }}
                  disabled={pickUpLoader}
                  icon="search"
                  placeholder="Search by showroom name, city or province..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
            </Col>
        </Row>
        <div 
          ref={scrollRef}
          className={"px-3 py-2 py-lg-3"}
          style={{
            maxHeight: isMobile ? '400px'  
                  : windowHeight < 1080 ? '65vh' 
                    : windowHeight >= 1080 && windowHeight < 1440 ? '70vh' 
                      : windowHeight >= 1440 && windowHeight < 2160 ? '75vh' 
                        : windowHeight >= 2160 && windowHeight < 2880 ? '77vh' 
                          : '80vh'
          ,
          overflowY: 'auto',
          overflowX: 'hidden',
          boxSizing: 'border-box',
          // boxShadow: filteredWarehouses.length > 3 ? 'inset 0 8px 8px -8px rgba(0, 0, 0, 0.15)' : ''
        }}>
          {/* {isManyWarehouse ? ( */}
          {filteredWarehouses.length > 0 ? (
            <WarehouseAccordionGrouped 
              // warehouses={warehouses}
              warehouses={filteredWarehouses}
              activeWarehouse={activeWarehouse}
              setActiveWarehouse={setActiveWarehouse} 
              setSelectedWarehouse={setSelectedWarehouse}
              isMobile={isMobile}
              scrollRef={scrollRef}
              pickUpLoader={pickUpLoader}
            />
          ):(
          <div>
            <h4 className="text-center">
              <Icon className="text-danger" name='exclamation' /> No showroom data available
            </h4>
            <Image src={noDataImage} size="medium" centered fluid />
          </div>
          )}
            
          {/* ):( */}
            {/* <Card.Group centered stackable itemsPerRow={isMobile ? 1 : 2}>
              {warehouses.map((warehouse) => (
                <Card
                  key={warehouse.id_warehouse}
                  fluid
                  style={{
                    borderBottom:
                      activeWarehouse === warehouse.id_warehouse
                        ? '2px solid #f2711c'
                        : '1px solid #d4d4d5',
                    cursor: pickUpLoader ? 'not-allowed' : 'pointer',
                  }}
                  onClick={() => {
                    if (!pickUpLoader) {
                      const scrollTop = scrollRef.current?.scrollTop;
                      setActiveWarehouse(warehouse.id_warehouse);
                      setSelectedWarehouse(warehouse.id_warehouse);
                      requestAnimationFrame(() => {
                        if (scrollRef.current && scrollTop !== undefined) {
                          scrollRef.current.scrollTop = scrollTop;
                        }
                      });
                    }
                  }}
                >
                  <Image
                    fluid
                    label={
                      activeWarehouse === warehouse.id_warehouse
                        ? {
                            as: 'a',
                            color: 'orange',
                            content: 'Selected',
                            icon: 'thumbtack',
                            size: 'mini',
                            ribbon: 'right',
                          }
                        : null
                    }
                    src="https://images.malkelapagading.com/tenant/Hoops-Indonesialogo-23.png"
                    wrapped
                    ui={false}
                  />
                  <Card.Content>
                    <Card.Header>{warehouse.name}</Card.Header>
                    <Card.Description>
                      {warehouse.qty > 1 ? (
                        <Label basic color="green" size="tiny">
                          <Icon name="check circle outline" />
                          Available
                        </Label>
                      ) : warehouse.qty === 1 ? (
                        <Label basic color="red" size="tiny">
                          <Icon name="exclamation" />
                          Only one left!
                        </Label>
                      ) : null}
                    </Card.Description>
                  </Card.Content>
                  <Card.Content extra>
                    <Icon name="warehouse" />
                    &nbsp;&nbsp;{warehouse.alias}
                  </Card.Content>
                </Card>
              ))}
            </Card.Group> */}
          {/* )} */}
        </div>
      </div>
    );
  };

  return (
    <section>
      <div
        style={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          overflowX: "unset",
          maxHeight: !isMobile ? "400px" : "unset",
        }}
      >
        <div
          className="custom-scrollbar"
          style={{
            display: "flex",
            flexDirection: isMobile ? "row" : "column",
            overflowX: isMobile ? "auto" : "hidden",
            overflowY: !isMobile ? "auto" : "unset",
            borderRight: !isMobile ? "1px solid #ddd" : "none",
            marginBottom: "1rem",
            paddingRight: isMobile ? '' : '',
            padding: isMobile ? "0.5rem" : "",
            maxHeight: !isMobile ? 
                windowHeight < 1080 ? '60vh' 
                  : windowHeight >= 1080 && windowHeight < 1440 ? '65vh' 
                    : windowHeight >= 1440 && windowHeight < 2160 ? '70vh' 
                      : windowHeight >= 2160 && windowHeight < 2880 ? '72vh' 
                        : '75vh' 
                          : "unset",
            boxShadow: 'inset 0 8px 8px -8px rgba(0, 0, 0, 0.15), inset 0 -8px 8px -8px rgba(0, 0, 0, 0.15)'
          }}
        >
          {panes.map((item, idx) => (
            <Popup
              content={
                // item.hasSize ? 
                // isMobile ? 
                // 'Already in your cart' : 
                // 'This size is already set in your cart' 
                // : 
                // !isMobile ? "This size will be available soon. Please check back later or see if it's available in the Online Store!"
                // : "It will be available soon!"
                "SOLD OUT!"
              }
              // disabled={!(item.qty <= 0) && !(item.hasSize)}
              disabled={!(item.qty <= 0)}
              position={!isMobile ? 'right center' : 'bottom right'}
              on={isMobile ? 'click' : 'hover'}
              inverted
              trigger={
                <div>
                    <Button
                      key={idx}
                      disabled={item.qty <= 0 || pickUpLoader || warehouseLoader}
                      onClick={() => {
                        setActiveIndex(idx);
                        getWarehouseDetail(idProduct, item.barcode);
                        setSelectedSizePickUp(item.size);
                        setSelectedBarcodePickUp(item.barcode);
                      }}
                      content={item.size}
                      style={{
                        backgroundColor: activeIndex === idx ? "#f2711c" : "#D4D4D5",
                        color: activeIndex === idx ? "#fff" : "#000",
                        borderRadius: 0,
                        minWidth: isMobile ? "60px" : "100px",
                        textAlign: "center",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: isMobile ? "auto" : "48px",
                        padding: isMobile ? "10px 5px" : "1.5rem",
                      }}
                    />
                </div>
              }
          />
          ))}
        </div>

        <div className="px-2" style={{ flex: 1 }}>
          {warehouseLoader ? (
            <TabPane style={{ border: 'none', boxShadow: 'none', padding: 0 }} loading>
              <Loader inverted>Loading Showroom...</Loader>
            </TabPane>
          ) : activeIndex === null ? (
            <TabPane style={{ border: 'none', boxShadow: 'none', padding: 0 }}>
              <div 
                style={!isMobile ? { position: "relative", top: "-3rem"} : {}}
              >
                <h4 className="text-center">
                  <Icon className="text-danger" name="exclamation" />
                  Please choose one of all product size to get the showroom data.
                </h4>
                <Image src={noDataImage} size="medium" centered fluid />
              </div>
            </TabPane>
          ) : panes[activeIndex] ? (
            <TabPane style={{ border: 'none', boxShadow: 'none', padding: 0 }}>
              <WarehouseCards warehouseDetailData={warehouseDetailData} />
            </TabPane>
          ) : null}
        </div>
      </div>
    </section>
  );
};

export default PickUpInStore;
